import {Box, BoxProps} from '@material-ui/core'
import React from 'react'

export const DefaultBox: React.FC<BoxProps> = (props) => (
  <Box bgcolor="background.paper" color="text.primary" borderRadius={8} p={3} {...props} />
)
